// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__ujBAI","colMin":"styles_colMin__kI9c_"};